/**
 * VendorSocialMediaService
 * Service for managing vendor social media links
 * Route: api/vendor-social-media
 * Controller: VendorSocialMediaController.cs (CCMS.Api.VendorManagement)
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor social media CRUD operations with vendor-specific queries
 */
export class VendorSocialMediaService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorSocialMediaService.DEFAULT_SERVICE_PATH,
            basePath: VendorSocialMediaService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all social media links for a specific vendor
     * @param vendorId - The vendor ID
     * @returns Array of vendor social media links
     */
    async getByVendor(vendorId) {
        const response = await this.getByVendorRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get all social media links for a specific vendor with full response
     * @param vendorId - The vendor ID
     * @returns ResponseData with array of vendor social media links
     */
    getByVendorRaw(vendorId) {
        const url = this.buildUrl(`vendor/${vendorId}`);
        return this.http.get(url);
    }
}
VendorSocialMediaService.DEFAULT_SERVICE_PATH = 'vendors';
VendorSocialMediaService.BASE_PATH = 'api/vendor-social-media';
//# sourceMappingURL=VendorSocialMediaService.js.map